import * as Language from "./language/language.slice";
import * as SettingsAction from "./settings/settingReducer";
import * as AreasAction from "./shipping-methods/shipping-reducer";
import * as LogoutAction from "./auth/logout/logout";
import * as LoaderAction from "./loader/loader";
import * as LoginAction from "./user/userReducer";
import * as APPUpdate from "./app/appUpdate";
import * as SettingErrorAction from "./settings/ErrorReducer";
import * as NotPersistAction from "./Non-persist/Non-persist";
import * as PkgActions from "./packages/packages";
import * as LogisticAction from "./Logistic/Logistic";
import * as ErrorAction from "./error/reducer";
import * as MenuAction from "./menu/menu-reducer";

export {
  ErrorAction,
  AreasAction,
  Language,
  SettingsAction,
  LoaderAction,
  LoginAction,
  LogoutAction,
  APPUpdate,
  SettingErrorAction,
  NotPersistAction,
  PkgActions,
  LogisticAction,
  MenuAction,
};
